import MoneyInput from '@cred/react-editors/money-input'
import { withFieldChangeEvent } from '@cred/react-analytics/hoc'

const MoneyInputWithAnalytics = withFieldChangeEvent(MoneyInput)

export default MoneyInputWithAnalytics
